import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthLayout, { CornerLogo, AUTH } from './AuthLayout';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    if (!email.trim()) {
      setError('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { email: email.trim() });
      navigate('/auth/email-sent', { state: { email: email.trim() } });
    } catch {
      // Backend always returns 200 to avoid email enumeration,
      // so a catch here means a network/server error.
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div
        style={{
          width: '100%',
          maxWidth: 480,
          backgroundColor: AUTH.cardBg,
          borderRadius: 16,
          padding: 40,
          boxShadow: 'var(--auth-card-shadow-box)',
          fontFamily: '"Geist", sans-serif',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 28,
            gap: 16,
          }}
        >
          <CornerLogo />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
            <h1
              style={{
                margin: 0,
                fontSize: 22,
                fontWeight: 700,
                color: AUTH.textPrimary,
                letterSpacing: '-0.03em',
                lineHeight: '28px',
                textAlign: 'center',
              }}
            >
              Reset your password
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                fontWeight: 400,
                color: AUTH.textSecondary,
                lineHeight: '18px',
                textAlign: 'center',
              }}
            >
              Enter your email and we&apos;ll send you a reset link.
            </p>
          </div>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
        {/* Email field */}
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 16, gap: 6 }}>
          <label
            style={{
              fontSize: 12,
              fontWeight: 500,
              color: AUTH.textPrimary,
              lineHeight: '16px',
            }}
          >
            Email
          </label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            style={{
              width: '100%',
              borderRadius: 8,
              border: `1.5px solid ${AUTH.inputBorder}`,
              backgroundColor: '#FAFAF9',
              padding: '12px 14px',
              fontSize: 14,
              fontWeight: 400,
              fontFamily: '"Geist", sans-serif',
              color: AUTH.textPrimary,
              outline: 'none',
              boxSizing: 'border-box',
            }}
            onFocus={(e) => { e.target.style.borderColor = AUTH.accent; }}
            onBlur={(e) => { e.target.style.borderColor = AUTH.inputBorder; }}
          />
        </div>

        {error && (
          <p style={{ margin: '0 0 12px', fontSize: 12, color: AUTH.textError, textAlign: 'center' }}>
            {error}
          </p>
        )}

        {/* CTA */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            borderRadius: 8,
            padding: '13px',
            backgroundColor: AUTH.accent,
            border: 'none',
            color: '#FFFFFF',
            fontSize: 14,
            fontWeight: 600,
            fontFamily: '"Geist", sans-serif',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            marginBottom: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {loading ? 'Sending\u2026' : 'Send reset link \u2192'}
        </button>
        </form>

        {/* Back link */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            type="button"
            onClick={() => navigate('/auth/login')}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 400,
              color: AUTH.textSecondary,
              fontFamily: '"Geist", sans-serif',
              lineHeight: '16px',
            }}
          >
            &larr; Back to sign in
          </button>
        </div>
      </div>
    </AuthLayout>
  );
}
